import setup from './setup.js';

export default {
  name: 'total-card-with-switch',
  props: {
    label: {
      type: String,
      required: true
    },
    count: {
      type: Number,
      required: true
    },
    selected: {
      type: Boolean,
      default: false
    },
    identifier: {
      type: String,
      required: true
    }
  },
  emits: ['update:selected', 'filterChange'],
  setup,
};
